import RecommendedProducts from "./RecommendedProducts";

export { RecommendedProducts };

export default RecommendedProducts;
